import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import { SearchIcon, XIcon } from '../ui/Icons';

const SidebarMenuSearch = ({ value, onChange, collapsed }) => {
  const { theme } = useTheme();
  if (collapsed) return null;

  return (
    <div className="px-2 pb-3">
      <div className="relative">
        <SearchIcon
          className={cn(
            'absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none',
            theme.text.muted
          )}
        />
        <input
          type="text"
          role="searchbox"
          aria-label="Search menu"
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search menu…"
          className={cn(
            'w-full pl-9 pr-8 py-2 text-sm rounded-lg border',
            theme.border.light,
            theme.colors.surface,
            theme.text.primary,
            'placeholder:opacity-60 focus:outline-none focus:ring-2 focus:ring-blue-500/40'
          )}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            className={cn(
              'absolute right-2 top-1/2 -translate-y-1/2 p-0.5 rounded',
              theme.text.muted,
              'hover:opacity-80'
            )}
            title="Clear search"
          >
            <XIcon className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SidebarMenuSearch;
